<template>
  <div class="ui bottom tab segment" data-tab="facility">
    <form class="ui form" :class="{'loading': form.waiting}">
      <div class="field">
        <button type="button" class="ui positive button" @click="save()">保存する</button>
      </div>
      <div class="ui stackable three column grid">
        <div v-for="each in facilities" :key="each.value" class="column">
          <div class="field">
            <div class="ui checkbox">
              <input v-model="each.checked" type="checkbox" value="true">
              <label>{{ each.label }}</label>
            </div>
           (
            <div class="ui checkbox" style="margin-right: 0;">
              <input v-model="each.is_conditional" type="checkbox" value="true" :disabled="!each.checked">
              <label>条件付き</label>
            </div>
           )
          </div>
          <div class="field">
            <textarea :disabled="!each.checked" rows="2" v-model="each.note" :placeholder="each.placeholder"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            model: {},
            facilities: [],
        };
    },
    methods: {
        initialize: function(model) {
            this.model = model;
            this.update(model.facilities);
        },
        update: function(facilities) {
            this.clearArray(this.facilities);
            _.forEach(this.consts.FACILITY, function(each) {
                var facilityModel = {
                    label: each.label,
                    facility_id: each.value,
                    placeholder: each.placeholder || '備考',
                    is_conditional: false,
                };
                var facility = _.find(facilities, { facility_id: each.value });
                if (facility) {
                    facilityModel.checked = true;
                    facilityModel.note = facility.note;
                    facilityModel.is_conditional = facility.is_conditional;
                }
                this.facilities.push(facilityModel);
            }.bind(this));
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        save: function() {
            this.form.model = {
                facilities: _.filter(this.facilities, {'checked': true})
            };
            this.form.put(this.model.update_facility_api_url, function(response) {
                this.update(response.data);
                alert('更新しました');
            }.bind(this));
        }
    }
};
</script>
